import {
  CateringServiceFeePayloadUI,
  CateringServiceFeeResponseUI,
} from 'src/types/CateringServiceFee';

export function transformCateringServiceFeeUIToModel(
  value: string
): CateringServiceFeePayloadUI {
  return {
    corpId: null,
    appliedFeeOverrides: [
      {
        feeType: 'CATERING',
        flexibleFeeType: 'CATERING',
        overrideAmountPercent: parseFloat(value),
      },
    ],
  };
}

export function transformCateringServiceFeeModelToUI(
  serviceFeeResponse: CateringServiceFeeResponseUI
): string {
  return (
    serviceFeeResponse?.feeOverrides?.[0]?.overrideAmountPercent?.toString() ??
    '0'
  );
}
